import AuthNavbar from 'components/navbar/auth';
import { Outlet, useLocation } from 'react-router-dom';
import hideInNativeMode from 'components/nativeMode/hideInNativeMode';

const Layout = (): JSX.Element => {
  const ConditionalAuthNavbar = hideInNativeMode(AuthNavbar);
  const location = useLocation();
  // Normalize pathname by removing trailing slash to handle /auth/login and /auth/login/
  const isLoginPage = location.pathname.replace(/\/$/, '') === '/auth/login';

  return (
    <div className={isLoginPage ? 'w-full max-w-md mx-auto px-4 sm:px-0' : 'w-full'}>
      <ConditionalAuthNavbar />
      <Outlet />
    </div>
  );
};

export default Layout;
